/**
 * Pulse Protocol — Autonomous AI agent scanner for Solana.
 *
 * @packageDocumentation
 * @see https://github.com/williambrowndev/pulse-protocol
 */

export { PulseProtocol } from "./core/client.js";
export { aggregate } from "./core/aggregator.js";
export { signVerdict, verifyVerdict } from "./core/signing.js";

export type {
  PulseConfig,
  ScanInput,
  Verdict,
  VerdictKind,
  SignalBundle,
  DetectorResult,
  ScanOptions,
  PublicVerdict,
} from "./core/types.js";

export { PulseError, ScanError, SourceError, SignatureError } from "./core/errors.js";

export const VERSION = "0.9.3";
